import React from 'react'

import { AuditResult } from '@core/entities/audit/AuditResult'
import { TimelineBriefingSessionRoleCard } from './TimelineBriefingSessionRoleCard'

type TimelineBriefingSessionBlockProps = {
  auditResult: AuditResult
}

const TimelineBriefingSessionBlock: React.FC<
  TimelineBriefingSessionBlockProps
> = ({ auditResult }) => {
  return (
    <>
      {auditResult.metadata?.briefedSessionData?.briefedSessionRoles.map(
        (role) => (
          <TimelineBriefingSessionRoleCard
            key={role.roleId}
            roleText={`${role.roleName} (${role.participants.length})`}
            participants={role.participants}
            // The "add participants without briefing" audit reuses the same role-card
            // UI but should not surface any briefing text — the backend still emits it
            // in the metadata, so we suppress it here.
            briefingText={
              auditResult?.isAddParticipantsAction()
                ? undefined
                : role.briefingText
            }
          />
        ),
      )}
    </>
  )
}

export { TimelineBriefingSessionBlock }
